import React from 'react'

import { DefaultHubColors, Hub, Event, HubColors } from '../../interfaces'
import CalendarDate from '../CalendarDate';
import { pickTextColor } from '../../utils/color_helpers';
import { trackHubEventClick } from '../../utils/gtag';
import classNames from 'classnames';

type Props = {
  hub: Hub
  event: Event
  hubColors?: HubColors
  className?: string
}

const HubEventTile = ({ hub, event, className, hubColors = DefaultHubColors }: Props) => {
  const eventUrl = `${process.env.NEXT_PUBLIC_BOX_OFFICE_BASE_URI}/events/${event.slug ?? event.id}`

  return (
    <div className={classNames("w-full p-4 text-white", className)}>
      <a
        href={eventUrl}
        onClick={() => trackHubEventClick({ hubId: hub.id, eventId: event.id, url: eventUrl })}
        className="c-card block bg-gray-800 hover:bg-gray-700 transition shadow-md hover:shadow-xl rounded-lg overflow-hidden h-full flex flex-col">
        <div className="p-4 flex-grow flex justify-between">
          <div className="flex flex-col justify-between">
            <p className="mt-2 mb-2 font-bold">{event.title}</p>
            <p className="text-sm">{event.short_description}</p>
            <p data-testid={`event-${event.id}-address`} className="text-sm" style={{ color: hubColors.primary }}>{[event.venue.name, event.venue.address].filter(venuePart => !!venuePart).join(", ")}</p>
          </div>
          <div className="m-2">
            <CalendarDate date={new Date(event.start_time)} colorHex={hubColors.primary} />
          </div>
        </div>
        <div data-testid={`event-${event.id}-get-tickets`} className="px-4 py-3 border-t border-gray-900" style={{ backgroundColor: hubColors.primary, color: pickTextColor(hubColors.primary, 'white', 'black') }}>
          <span className="flex items-center mb-1 font-bold" >
            Get tickets
          </span>
        </div>
      </a>
    </div>
  )
}

export default HubEventTile
